import styles from "./Wallet.module.css";

import { ReactComponent as BackIcon } from "../../../assets/svg/category-back.svg";

import { useTranslation } from "react-i18next";
import { useQuery } from "@apollo/client";
import {
  TransactionsList,
  WalletQuery,
} from "../../../graphql/none_saleor/wallet/wallet";
import { useEffect, useState } from "react";
import { Note, Uniter } from "../../../helbest";
import Transaction from "./Transaction";
import { mapEdgesToNodes, toFixedNumber } from "../../../base/utils";
import { useInfiniteScroll } from "../../../hooks/useInfiniteScroll";
import { Button, Drawer, Spin } from "antd";
import AddWallet from "./AddWallet";
import { useSelector } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import { COLORS } from "../../../base/style";
import { useLangNavigate } from "../../../hooks/useLangNavigate";

const ITEMS_PER_PAGE = 20;

const Wallet = () => {
  const Login = useSelector((state) => state.Login);

  const [addFund, setAddFund] = useState(false);
  const { t, i18n } = useTranslation();

  const navigate = useLangNavigate();

  const { data: walletCredit, refetch: getWalletDetails } = useQuery(
    WalletQuery,
    {
      variables: {
        first: ITEMS_PER_PAGE,
        offset: 0,
        channel: Login.channel,
      },
      context: {
        // headers: {
        //   "site-url": "garajmall.com",
        // },
        clientName: "wallet",
      },
      onError: (err) => {
        Note.error(err.message);
      },
    }
  );

  useEffect(() => {
    if (addFund) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [addFund]);

  useEffect(() => {
    if (Login?.is_login) getWalletDetails();
    else
      navigate("/login", {
        state: { from: "/wallet" },
        replace: false,
      });
  }, []);

  const {
    items: transactions,
    loading,
    hasMore,
    loadMoreRef,
  } = useInfiniteScroll({
    query: TransactionsList,
    queryName: "walletTransactions",
    itemsPerPage: 20,
    clientName: "wallet",
    mapFunction: mapEdgesToNodes,
    variables: {
      channel: Login.channel,
    },
  });

  const walletHeader = () => (
    <div className={styles.headerContainer}>
      <div className={styles.headerIconContainer} onClick={() => navigate("/")}>
        <BackIcon
          style={{
            rotate: i18n.dir() === "rtl" ? "180deg" : "0",
          }}
        />
      </div>
      <span className={styles.DetailHeaderTitleWhite}>{t("wallet.title")}</span>
    </div>
  );

  return (
    <div>
      <div
        className={`w-full flex flex-column items-center ${styles.WalletWrapper}`}
      >
        {walletHeader()}
        <div className={styles.CardInfo} dir="ltr">
          <div className={styles.CreditTitle}>{t("wallet.my")}</div>
          <div className={styles.CreditValue}>
            {walletCredit?.wallet.balance ? (
              <Uniter childSize={24} unitSize={14} unit="OMR">
                {Number(toFixedNumber(walletCredit?.wallet.balance))}
              </Uniter>
            ) : (
              <Spin
                size="default"
                style={{ color: "#ffffff" }}
                className="white-spinner"
              />
            )}
          </div>
          <Button
            onClick={() => setAddFund(true)}
            icon={<PlusOutlined />}
            type="primary"
            size="small"
            style={{
              color: COLORS.primary,
              backgroundColor: "#fff",
              borderRadius: "10px",
              gap: "4px",
            }}
          >
            {t("wallet.add_funds")}
          </Button>
        </div>
      </div>
      <div className={styles.PaymentMethods}>
        <div className={styles.Thumb}>
          <div />
        </div>
        <div className={styles.PaymentMethodsContainer}>
          {transactions.length === 0 && !loading ? (
            <div className={styles.emptyTransaction}>
              {t("wallet.empty_transaction")}
            </div>
          ) : null}
          {transactions.map((transaction) => (
            <Transaction key={transaction.id} data={transaction} />
          ))}
        </div>

        {/* Loading indicator */}
        {loading ? (
          <div className="flex center-content" style={{ marginBottom: "60px" }}>
            <Spin />
          </div>
        ) : null}

        {/* Invisible load more trigger */}
        {hasMore && !loading ? (
          <div ref={loadMoreRef} style={{ height: "40px" }} />
        ) : null}
      </div>
      <Drawer
        title={t("cart.payment_option")}
        placement="bottom"
        onClose={() => setAddFund(false)}
        open={addFund}
        key="bottom"
        classNames={{
          content: styles.DrawerContent,
          header: styles.DrawerHeader,
        }}
        styles={{
          body: {
            padding: 0,
          },
        }}
        height={425}
      >
        <div className={styles.DrawerBody}>
          <AddWallet />
        </div>
      </Drawer>
    </div>
  );
};

export default Wallet;
